export const headings = {
    '1': {
        fontSize: 'xl',
        lineHeight: 'xl',
        fontWeight: 'headingMain',
        textDecoration: 'none',
        letterSpacing: 'normal',
        color: 'default',
    },
    '2': {
        fontSize: 'l',
        lineHeight: 'l',
        fontWeight: 'heading',
        textDecoration: 'none',
        letterSpacing: 'normal',
        color: 'default',
    },
    '3': {
        fontSize: 'm',
        lineHeight: 'm',
        fontWeight: 'heading',
        textDecoration: 'none',
        letterSpacing: 'normal',
        color: 'default',
    },
    '4': {
        fontSize: 's',
        lineHeight: 'm',
        fontWeight: 'heading',
        textDecoration: 'none',
        letterSpacing: 'normal',
        color: 'default',
    },
    '5': {
        fontSize: 'xs',
        lineHeight: 's',
        fontWeight: 'heading',
        textDecoration: 'uppercase',
        letterSpacing: 'wide',
        color: 'secondary',
    },
};
//# sourceMappingURL=headings.js.map